// Desc: This file contains the props for the components in the project
//       It is used to pass data to the components in the project
import { doc } from "firebase/firestore";
import logo from "./images/logo/Center.png";
import WaveSurfer from "wavesurfer.js";
import WavesurferPlayer from "@wavesurfer/react";

import { useRef, useEffect } from "react";
export function Downloadmenu(props) {
  if (props.menu === 1) {
    return (
      <div className="link">
        <div className="audio">
          <div className="top">
            <h3 className="centerelements">Audio Preview</h3>             
            <WavesurferPlayer
                  progressColor={"white"}
                  url={props.link}
                  height={100}
                  onClick={(e) => e.play()}
                  hideScrollbar={true}
                  mediaControls={true}
                />

          </div>
          </div>
      </div>
    );
  } else if (props.menu === 2) {
    return (
      <div className="link">
        <a href="/" className="bigbutton">
          <div className="centerelements">
            <div className="centerelements inner">
              <h3>Download</h3>
            </div>
          </div>
        </a>
        <a href="/" className="bigbutton">
          <div className="centerelements">
            <div className="centerelements inner">
              <h3>Trailer</h3>
            </div>
          </div>
        </a>
      </div>
    );
  } else if (props.menu === 3) {
    return (
      <div className="link">
        <a href={props.link} className="bigbutton">
          <div className="centerelements">
            <div className="centerelements inner">
              <h3>Link</h3>
            </div>
          </div>
        </a>
      </div>
    );
  }
}

export function Navbar(props) {
  let content;
  if (props.fixed === "true") {
    content = (
      <nav className="navbarcustom fixed" id="nav">
        <div className="">
          <ul className="">
            <li className="title">
              <a id="title" href="/">
                S.H.A.R.D
              </a>
            </li>
            <li className="img">
              <img id="" src={logo} alt="Logo"></img>
            </li>
            <li className="">
              <a id="homebutton" href="/#Home">
                Home
              </a>
            </li>
            <li className="">
              <a id="projectsbutton" href="/#Projects">
                Projects
              </a>
            </li>
            <li className="">
              <a id="aboutbutton" href="/#About">
                About
              </a>
            </li>
            <li className="">
              <a id="contactbutton" href="/#Resources">
                Contact
              </a>
            </li>
          </ul>
        </div>
      </nav>
    );
  } else {
    content = (
      <nav className="navbarcustom " id="nav">
        <div className="">
          <ul className="">
            <li className="title">
              <a id="title" href="/">
                S.H.A.R.D
              </a>
            </li>
            <li className="img">
              <img id="" src={logo} alt="Logo"></img>
            </li>
            <li className="">
              <a className="btn" href="/#Home">
                Home
              </a>
            </li>
            <li className="">
              <a className="btn" href="/#Projects">
                Projects
              </a>
            </li>
            <li className="">
              <a className="btn" href="/#About">
                About
              </a>
            </li>
            <li className="">
              <a className="btn" href="/#Resources">
                Contact
              </a>
            </li>
          </ul>
        </div>
      </nav>
    );
  }
  return content;
}

export default function props() {
  return null;
}
